var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideViewDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg7613",
    viewBox: "0 0 236 386",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7413"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style7411"
  }, ".a{fill:#2f7dac}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-363.22 -482.703)",
    id: "g7611",
    style: {
      opacity: 1,
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      fill: "none",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(447.387 483.74) scale(1.03757)",
    id: "g7593",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7591",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M194.233 339.13s-1.415 9.471-3.785 37.528c-1.172 13.871-1.563 20.519-1.728 26.33-.123 4.3-5.857 6.914-10.338 5.484-4.78-1.525-3.163 2.753-1.598-5.498 2.1-11.079-11.562-47.541-4.661-63.052 6.176-13.882 21.62-.55 22.11-.792z",
    transform: "translate(-157.45 -60.52)",
    id: "path7507",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.724 154.883)",
    id: "g7521",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M198.389 316.751s4.449-30.01 5.554-43.558c.418-5.129.8-11.478 1.121-16.5.812-13.16.141-26.371-2-39.382l-37.906-.464s-6.625 8.948-4.931 23.31c1.4 11.857 10.855 23.038 12.986 34.21 2.131 11.172 1.75 12.428 2.788 19.83 1.038 7.402 2.95 22.772 2.95 22.772s.22 7.31-.975 10.576a16.624 16.624 0 0 1-1.766 3.965 15.462 15.462 0 0 1 8.555-.33c4.442 1.213 10.418 3.405 10.418 3.405s.71-3.557 1.118-6.091a17.5 17.5 0 0 0 2.088-11.743z",
    transform: "translate(-158.347 -216.841)",
    id: "path7519",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.867)",
    id: "g7571",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M209.731 113.97c9.44-8.262-3.085-39.64-3.085-39.64s-1.637-9.212-15.718-10.186c-13.178-.913-20.385 5.179-24.4 13.873-6.663 14.46 8.865 31.9 8.865 31.9 5.793 1.983 15.118 18.34 34.338 4.052z",
    transform: "translate(-161.423 -64.054)",
    id: "path7539",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.164 30.233)",
    id: "g7545",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.272 103.592a2.468 2.468 0 0 1-2.024.254c-.973-.471-2.259-1.252-4.164-4.5a3.7 3.7 0 0 1 1.171-5.405c.527-.273 3.607.22 5.015 5.445",
    transform: "translate(-179.387 -93.878)",
    id: "path7543",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M200.4 127.264c7.974 9.637 4.222 67.736 3.776 69.682.62 21.635-2.603 18.059-2.603 18.059l-35.927-1.087s-8.375-63.082-1.467-79.107c0 0 5.917-18.049 19.341-13.211 4.18 1.5 12.22.031 16.88 5.664z",
    transform: "translate(-161.469 -63.276)",
    id: "path7547",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.989 348.557)",
    id: "g7565",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M173.741 409.675s-1.656 8.011-1.406 10.66c.25 2.649.871 2.961 1.784 3.751 1.56 1.351 2.765 1.375 7.24.916 4.475-.459 7.809-.783 10.671.42 2.862 1.203 10.988 4.14 15.024 3.885a22.423 22.423 0 0 0 12.629-4.82c1.93-1.742-.982-3.4-.982-3.4s-5.5.018-7.9-1.236c-2.4-1.254-20.767-11.956-20.767-11.956s-6.441 6.182-16.293 1.78z",
    transform: "translate(-172.31 -407.894)",
    id: "path7559",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M166.89 140.371c3.09-12.195 13.173-12.793 13.173-12.793l3.544 1.646s3.597 14.28 2.097 22.352c-.973 5.242-1.705 18.666-1.94 25.359-.196 5.526-2.244 16.849-2.244 16.849.041 1.227 2.32 8.15 2.532 9.514 1.265 8.107 2.031 12.9 1.532 22-.446 8.12 1.025 20.584 1.025 20.584l-9.328 1.227s-9.35-45.745-9.164-51.052c.02-.546-1.386-43.033-1.228-55.686z",
    transform: "translate(-157.546 -63.2)",
    id: "path7573",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.568 183.342)",
    id: "g7589",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.461 247.427s3.828 12.887 3.874 14.064l.422 10.946-3.276 9.783s-1.2-.607-.955-2.77c.262-2.333 1.531-7.643 1.38-8.159-.151-.516-1.138-7.575-1.138-7.575l-.36 7.583s-1.674 7.372-2.019 8.56c-.345 1.188-1.553 3.714-2.21 3.609-.657-.105-.79-2.71-.71-4.018.08-1.308 1.11-9.308 1.11-9.308l-.742-5.71-1.142 8.132s-.651 6.289-.882 7.081c-.231.792-1.658.977-2.035-2.009-.377-2.986.2-8.36.145-9.794-.055-1.434-.061-4.956-.061-4.956s-1.045 5.073-1.115 6.641c-.07 1.568-.36 6.69-.338 7.947.032 2.056-2.409-7.643-2.409-7.643l.98-10.62s1.514-9.034 2.296-11.276z",
    transform: "translate(-173.999 -244.915)",
    id: "path7577",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 2.89137118,
      strokeMiterlimit: 4,
      strokeDasharray: "8.67411355,2.89137118",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideViewDashed);
export default __webpack_public_path__ + "static/media/side-view-dashed.e9def843f27f26d77a4db857ff1e57b4.svg";
export { ForwardRef as ReactComponent };